import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
	name: 'callback',
	pure: false,
})
export class CallbackPipe implements PipeTransform {
	transform(items: any[], callback: (item: any, ...arguments_: any[]) => boolean, ...arguments_: any[]): any {
		if (!items || !callback) {
			return items;
		}
		return items.filter((item) => callback(item, ...arguments_));
	}
}
